import { MessageBar, MessageBarType, Toggle } from 'office-ui-fabric-react';
import React, { useState } from 'react'
import { ProjectSettings } from '../../../store/ProjectsListStore';
import { ConfirmationDialog } from '../../common/ConfirmationDialog';

type Props = {
    readonly?: boolean,
    value: boolean;
    originalValue: boolean;
    allowTimeTracking: boolean;
    onChange: (changes: Partial<ProjectSettings>) => void;
    isGlobalSettingEnabled: boolean;
    isPrivateProject: boolean;
};

export default function TimeTrackingProjectSettingsSection(props: Props) {
    const { readonly, value, onChange, isGlobalSettingEnabled, originalValue, isPrivateProject, allowTimeTracking } = props;
    const [showCompletedWorkConfirmation, setShowCompletedWorkConfirmation] = useState(false);
    const isTimeTrackingAllowed = allowTimeTracking && !isPrivateProject;

    return (
        <>
            <div className='section-description'>
                Select whether users can track time for the current project.
            </div>
            <ul className="cb-list">
                <li>
                    <div className="cb-wrap">
                        <div className="title">Allow time to be tracked for the project</div>
                        <Toggle
                            checked={isTimeTrackingAllowed}
                            disabled={readonly || isPrivateProject}
                            onChange={(e: any, c?: boolean) => onChange({ allowTimeTracking: c! })}
                        />
                    </div>
                </li>
            </ul>

            <div className='section-description'>
                Select whether Completed Work for PPM Express tasks should be calculated based on the reported time.
            </div>
            <ul className="cb-list">
                <li>
                    <div className="cb-wrap">
                        <div className="title">Record Reported Time to Completed Work</div>
                        <Toggle
                            checked={value && isTimeTrackingAllowed}
                            disabled={readonly || !isGlobalSettingEnabled || !isTimeTrackingAllowed}
                            onChange={(e: any, c?: boolean) => {
                                if (c && !originalValue) {
                                    setShowCompletedWorkConfirmation(true);
                                }
                                else {
                                    onChange({ calculateCompletedWorkBasedOnReportedTime: c! });
                                }
                            }}
                        />
                    </div>
                </li>
            </ul>

            {!isGlobalSettingEnabled
                ? <MessageBar messageBarType={MessageBarType.warning} isMultiline>
                    This setting is ignored as the Global setting is turned off.
                    {isPrivateProject ? <><br />Time cannot be reported for Private Projects.</> : undefined}
                </MessageBar>
                : isPrivateProject
                    ? <MessageBar messageBarType={MessageBarType.warning} isMultiline>
                        Time cannot be reported for Private Projects.
                    </MessageBar>
                    : undefined
            }

            {showCompletedWorkConfirmation &&
                <ConfirmationDialog
                    dialogContentProps={{
                        isMultiline: true,
                        title: "Confirm this action",
                        subText: `Are you sure you want to enable recording of the Reported Time to Tasks Completed Work in this Project?
                    Tasks Completed Work will be recalculated immediately using the time reported in Users Timesheets.`
                    }}
                    onNo={() => { }}
                    onDismiss={() => setShowCompletedWorkConfirmation(false)}
                    onYes={() => onChange({ calculateCompletedWorkBasedOnReportedTime: true })}
                />}
        </>);
}
